import { render, staticRenderFns } from "./ListAtlasFiles.vue?vue&type=template&id=68064dd3"
import script from "./ListAtlasFiles.vue?vue&type=script&lang=ts"
export * from "./ListAtlasFiles.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports